module.exports = __webpack_public_path__ + "static/img/applogo.bbe1ff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/applogo.png
// module id = Rvcu
// module chunks = 19